import React, { useState } from 'react';
import { LoanNote } from '../types';
import { getInitials } from '../utils/retention';
interface NoteTrailProps {
  notes: LoanNote[];
  onAddNote: (body: string) => void;
}
function formatTimestamp(iso: string) {
  const date = new Date(iso);
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  });
}
export function NoteTrail({
  notes,
  onAddNote
}: NoteTrailProps) {
  const [draft, setDraft] = useState('');
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const body = draft.trim();
    if (!body) return;
    onAddNote(body);
    setDraft('');
  };
  return <section aria-label="Note trail" className="flex min-h-0 flex-1 flex-col gap-3" data-id="element-99" data-mp="6uje3m8qa9eb">
      <h3 className="text-[11px] font-medium uppercase tracking-[0.12em] text-brand-300" data-id="element-100" data-mp="149xdbjfyy9y6">
        Note Trail
      </h3>

      <ol className="min-h-0 flex-1 space-y-4 overflow-y-auto pr-1" data-id="element-101" data-mp="zixe27jdnfsi">
        {notes.map((note, index) => <li key={note.id} className="relative flex gap-3 pb-1" data-id="element-102" data-mp="10vbxzmzvaekw" data-mpi={index}>
            {index !== notes.length - 1 && <span aria-hidden="true" className="absolute left-[13px] top-8 h-[calc(100%-12px)] w-px bg-brand-200" data-id="element-103" data-mp="14ukugzmakqk5" />}
            <span aria-hidden="true" className="relative z-10 flex h-[27px] w-[27px] shrink-0 items-center justify-center rounded-full border border-brand-200 bg-white text-[9.5px] font-semibold text-brand-400" data-id="element-104" data-mp="w2r6is4fodkj">
              {getInitials(note.author)}
            </span>
            <div className="min-w-0 pt-0.5" data-id="element-105" data-mp="86n3w7x8b9in">
              <p className="flex flex-wrap items-baseline gap-x-2 text-[13px]" data-id="element-106" data-mp="87yasglz0xdz">
                <span className="font-semibold text-brand-500" data-id="element-107" data-mp="d4ydchjm3i0c">
                  {note.author}
                </span>
                <span className="text-xs text-brand-300" data-id="element-108" data-mp="22hs2uyxdexrn">
                  {formatTimestamp(note.createdAt)}
                </span>
              </p>
              <p className="mt-0.5 text-[13px] leading-relaxed text-brand-400" data-id="element-109" data-mp="25541r2haokbu">
                {note.body}
              </p>
            </div>
          </li>)}
      </ol>

      <form onSubmit={handleSubmit} className="flex items-center gap-2" data-id="element-110" data-mp="1w2usefxrix01">
        <label htmlFor="note-draft" className="sr-only" data-id="element-111" data-mp="1r49p27n7rx7d">
          Add a note to this file
        </label>
        <input id="note-draft" value={draft} onChange={event => setDraft(event.target.value)} placeholder="Log a call, voicemail, or next step…" className="h-10 w-full rounded-xl border border-brand-200 bg-white px-3.5 text-[13px] text-brand-500 placeholder:text-brand-300 focus:border-accent-500 focus:outline-none focus:ring-2 focus:ring-accent-500" data-id="element-112" data-mp="2ors7ybalafp3" />
        <button type="submit" disabled={!draft.trim()} className="h-10 shrink-0 rounded-xl border border-brand-200 bg-white px-4 text-[13px] font-semibold text-brand-500 transition-colors hover:bg-brand-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-500 disabled:pointer-events-none disabled:opacity-40" data-id="element-113" data-mp="37j1k6sbqvikd">
          Add note
        </button>
      </form>
    </section>;
}